export const handleBeforeInputNumber = (e) => {
    if (e.isComposing) return;

    if (e.data && !/^\d+$/.test(e.data)) {
        e.preventDefault();
    }
};
export const handlePasteNumber = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text');
    const onlyNumber = text.replace(/\D+/g, '');
    document.execCommand('insertText', false, onlyNumber);
};

export const handleInputNumberWithMaxLength = (e, maxLength) => {
    let value = e.target.value;

    value = value.replace(/\D+/g, '');

    if (value.length > maxLength) {
        value = value.slice(0, maxLength);
    }

    e.target.value = value;
};

export const KataNumberReg = /^(([ァ-ン]|ー)|[0-9])*$/;
export const handleKeyPressKataNumberText = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!KataNumberReg.test(keyValue)) {
        event.preventDefault();
    }
};
